import React, { Component } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import PropTypes from 'prop-types';
import { translations } from '../../../sharedJs/translations';
import EpiLink from '../../links/epiLink/EpiLink';
import FeedbackBar from '../../feedbackBar/FeedbackBar';
import SvgElement from '../../uiElements/svgElement/SvgElement';
import ContributorsBlock from '../../miljostatusComponents/contributorsBlock/ContributorsBlock';

import '../../../styles/_utilities.scss';
import '../../../styles/_grid.scss';
import './_footer.scss';

const footerLogoMiljostatus = '/assets/miljostatus/logo/logo_miljostatus_hvit.svg';
const footerLogoMiljostatusEnglish = '/assets/miljostatus/logo/logo_miljostatus_engelsk_hvit.svg';
const arrowWhite = '/assets/miljostatus/icons/icon-arrow-right-white.svg';

class Footer extends Component {
    constructor() {
        super();
        autoBind(this);
    }

    onLanguageChange(event) {
        this.props.changeLanguage(event.target.value);
        if (event.target.value === 'en') {
            window.location = 'https://www.environment.no/';
        } else {
            window.location = 'https://miljostatus.miljodirektoratet.no/';
        }
        document.getElementsByTagName('html')[0].setAttribute('lang', event.target.value);
    }

    getClassName() {
        return 'c_master-footer c_master-footer--miljostatus';
    }

    getMultilineText(text) {
        const match = /\n/.exec(text);
        if (match) {
            return text.split('\n').map(i =>
                <span key={`multiLineKey_${i}`}>{i}<br /></span>);
        }
        return <span>{text}</span>;
    }

    render() {
        // TODO: Change document.location.pathname below with pageUrl
        if (!this.props.epiDataModel || !this.props.epiDataModelLoaded) {
            return null;
        }
        const {
            showFeedbackBar,
            url: pageUrl,
            pageHeading,
            category,
            hideContributors,
            contributors
        } = this.props.epiDataModel;

        const {
            email,
            footerLinks,
            privacyLinks,
            postAddress,
            phone,
            visitorAddress,
            social
        } = this.props.epiDataModel.footer;

        const translate = translations(this.props.language.name);        

        return (
            <footer className={this.getClassName()} key={document.location.pathname}>
                {!hideContributors && contributors && contributors.length > 0 &&
                <ContributorsBlock
                    heading={translate.App.ContributorsToMiljostatus}
                    contributors={contributors}
                />
                }
                {showFeedbackBar &&
                <FeedbackBar
                    pageInfo={{ pageUrl, pageHeading, category }}
                    lang={this.props.language.name}
                />
                }
                <div className="c_master-footer-content">
                    <div className="g_container g_container--full">
                        <div className="g_row g_row--top">
                            <div className="g_col g_col--large-4">
                                <EpiLink url="/">
                                    <span className="u_visuallyhidden">{translate.App.BackToFrontPage}</span>
                                    <SvgElement
                                        src={this.props.language.name === 'en' ? footerLogoMiljostatusEnglish : footerLogoMiljostatus}
                                        title={translate.App.BackToFrontPage}
                                        desc={translate.App.GoBackToFrontPage}
                                        className="c_master-footer__logo"
                                    />
                                </EpiLink>
                            </div>
                            <div className="g_col g_col--large-8 c_master-footer__links-wrapper">
                                <div className="g_col g_col--large-9">
                                    <ul className="c_master-footer__link-list c_master-footer__link-list--main">
                                        {footerLinks && footerLinks.map(link => (
                                            <li key={`linkList_key__${link.name}`}>
                                                <EpiLink url={link.url}>{link.name}</EpiLink>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="g_col g_col--large-3">
                                    <label className="c_language-select" htmlFor="languageSelect">
                                        <span className="u_visuallyhidden">{translate.App.ChooseLanguage}:</span>
                                        <select
                                            id="languageSelect"
                                            onChange={e => this.onLanguageChange(e)}
                                            value={this.props.selectedLanguage}
                                        >
                                            <option value="-1" disabled>{translate.App.Language}</option>
                                            {this.props.language.name === 'en' ?
                                                <option value="no">{translate.App.Norsk}</option>
                                                :
                                                <option value="en">{translate.App.English}</option>
                                            }
                                        </select>
                                        <span className="c_language-select__arrow-wrapper">
                                            <SvgElement
                                                src={arrowWhite}
                                                title={translate.App.Arrow}
                                                desc={translate.App.Choose}
                                            />
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="g_row">
                            <div className="u_visuallyhidden">
                                <h2 className="u_hide-from-anchor-menu">{translate.App.ContactInformation}</h2>
                            </div>
                            <div className="g_col g_col--large-4">
                                <div className="c_master-footer__mail-phone-wrapper">
                                    <div>
                                        <span>{translate.App.Email}: </span>
                                        <a href={`mailto:${email}`} className="c_master-footer__email">
                                            <span className="u_visuallyhidden">{translate.App.Email}: </span>
                                            {email}
                                        </a>
                                    </div>
                                    {(phone) &&
                                    <div>
                                        <span>{translate.App.Phone}: </span>
                                        {phone && phone.length > 0 &&
                                        <span>
                                            <a
                                                href={`tel:${phone.replace(/\s+/g, '')}`}
                                                className="c_master-footer__phone"
                                            >
                                                <span className="u_visuallyhidden">{translate.App.Phone}:</span> {phone}
                                            </a>
                                        </span>
                                        }
                                    </div>
                                    }
                                </div>
                            </div>
                            <div className="g_col g_col--large-8">
                                {postAddress &&
                                <div className="g_col g_col--large-4 c_master-footer__address-wrapper">
                                    <div className="c_master-footer__address-header"><h3>{translate.App.PostAddress}</h3><span>:</span>
                                    </div>
                                    <address aria-label={translate.App.PostAddress}>
                                        {this.getMultilineText(postAddress)}
                                    </address>
                                </div>
                                }
                                {visitorAddress &&
                                <div className="g_col g_col--large-5 c_master-footer__address-wrapper">
                                    <div className="c_master-footer__address-header">
                                        <h3>{translate.App.VisitationAddress}</h3>
                                        <span>:</span>
                                    </div>
                                    <address
                                        aria-label={translate.App.VisitationAddress}
                                    >
                                        {this.getMultilineText(visitorAddress)}
                                    </address>
                                </div>
                                }
                                <div className="g_col g_col--large-3 c_master-footer__social-wrapper">
                                    {social &&
                                    <ul>
                                        {social.map(link => (
                                            <li key={`socialList_key__${link.name}`}>
                                                <EpiLink url={link.url}>{link.name}</EpiLink>
                                            </li>
                                        ))}
                                    </ul>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="g_row c_master-footer__privacy-row">
                            <div className="g_col g_col--large-12">
                                <h2 className="u_visuallyhidden u_hide-from-anchor-menu">{translate.App.Privacy}</h2>
                                {privacyLinks && privacyLinks.length > 0 &&
                                <ul>
                                    {privacyLinks.map(link => (
                                        <li key={`privacyLinkList_key__${link.name}`}>
                                            <EpiLink url={link.url}>{link.name}</EpiLink>
                                        </li>
                                    ))}
                                </ul>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <a
                    href="#content"
                    className="skipLink skipLink--bottom"
                >{translate.App.SkipToMainContent}
                </a>
            </footer>
        );
    }
}

Footer.propTypes = {
    changeLanguage: PropTypes.func,
    language: PropTypes.object,
    selectedLanguage: PropTypes.string,
    epiDataModel: PropTypes.object,
    epiDataModelLoaded: PropTypes.bool
};

const mapStateToProps = state => ({
    language: state.app.language,
    epiDataModel: state.app.epiDataModel,
    epiDataModelLoaded: state.app.epiDataModelLoaded
});

export default connect(mapStateToProps, {})(Footer);
